import React, { createContext, useState, useContext, ReactNode } from "react";

type MessageType = "success" | "error" | "info" | "warning";

interface MessageContextProps {
  message: string;
  type: MessageType;
  /** Optional sentence under the message, in normal text (e.g. why Claude handed a reply back). */
  detail: string;
  setMessage: (message: string, type: MessageType, detail?: string) => void;
}

const MessageContext = createContext<MessageContextProps | undefined>(
  undefined
);

export const useMessage = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error("useMessage must be used within a MessageProvider");
  }
  return context;
};

export const MessageProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState<string>("");
  const [type, setType] = useState<MessageType>("success");
  const [detail, setDetail] = useState<string>("");

  const setMessageWithType = (
    msg: string,
    msgType: MessageType,
    msgDetail?: string
  ) => {
    setMessage(msg);
    setType(msgType);
    setDetail(msgDetail ?? "");
  };

  return (
    <MessageContext.Provider
      value={{ message, type, detail, setMessage: setMessageWithType }}
    >
      {children}
    </MessageContext.Provider>
  );
};
